import { palette } from '../palette.js';
import { utils } from '../utils.js';
import { historie } from '../history.js';
import { beads } from '../beads.js';
import { settings } from '../settings.js';
import { allData } from '../../lib/alldata_2023_1';

export const beadLibrary = {};

const getBeadsToShow = ({method, str, inputColor, collection}) => {

    const mySwatch = b3.store.state.swatches.find(s => s.id === palette.activeStyleId);

    if (method === 'color') {
        const color = inputColor || mySwatch.fillColor;
        const myColor = Phaser.Display.Color.IntegerToColor(color);
        return beadLibrary.sortBeadsByColor(myColor.r, myColor.g, myColor.b);
    } else if (method === 'filter') {
        return beadLibrary.filterBeads(str.toLowerCase());
    } else if (method === 'stock') {
        return beadLibrary.getStock();
    } else if (method === 'stash') {
        return beadLibrary.getStash({collection});
    }
};

const getAllBeads = () => {
    const myCustomBeads = b3.store.state.customBeads.filter(b => b.id.slice(0, 3) === 'ZZZ')
    return allData.concat(myCustomBeads);
};

// overwrite library bead with user's custom changes
const overwrite = bead => {
    const customBead = b3.store.state.customBeads.find(b => b.id === bead.id);
    if (!customBead) return bead;

    return {
        ...bead,
        ...customBead
    };
};

beadLibrary.getStock = () => {

    return getAllBeads()
        .filter(bead => bead.a === settings.library.index)
        .map(bead => overwrite(bead))
        .filter(bead => typeof bead.stock === 'number')
        .sort((a, b) => a.stock - b.stock > 0 ? -1 : 1)
};

beadLibrary.getStash = ({collection}) => {
    if (!collection?.beadIdList) return

    return getAllBeads()
        .filter(bead => bead.a === settings.library.index)
        .filter(element => collection.beadIdList.includes(element.id))
        .map(bead => overwrite(bead));
};

beadLibrary.convertLibraryBead = element => {
    return {
        fillColor: element.fillColor || Phaser.Display.Color.GetColor(...element.c),
        title: element.title || element.id,
        id: element.id,
        details: element.details || element.t,
        description: element.description || element.dt,
        secondColor: element.secondColor || null,
        inner: element.inner || 'opaque',
        finishName: element.finishName || utils.finishes[element.b],
        stock: element.stock ?? null
    }
};

beadLibrary.displayBeads = ({method, str='', color, collection}) => {
    if (b3.store.state.showingModal === 'swatch-edit') return;

    const beadsToShow = getBeadsToShow({method, str, inputColor: color, collection});

    const myBeads = beadsToShow.map(element => beadLibrary.convertLibraryBead(element));

    b3.store.mySet('beadsToShow', myBeads);
};

beadLibrary.resetEntry = ({id}) => {
    const swatch = getAllBeads().find(e => e.id === id);
    if (!swatch) return;
    beadLibrary.updateEntry({swatch});
};

beadLibrary.updateEntry = ({swatch}) => {

    const myBead = b3.store.state.beadsToShow.find(e => e.id === swatch.id);
    if (!myBead) return;

    myBead.fillColor = swatch.fillColor || Phaser.Display.Color.GetColor(...swatch.c);
    myBead.title = swatch.title || swatch.id;
    myBead.id = swatch.id;
    myBead.details = swatch.details || swatch.t;
    myBead.description = swatch.description || swatch.dt;
    myBead.secondColor = swatch.secondColor || null;
    myBead.inner = swatch.inner || 'opaque';
    myBead.finishName = swatch.finishName || utils.finishes[swatch.b];
    myBead.stock = swatch.stock ?? null;
};

beadLibrary.addSwatchFromLibrary = item => {

    if (!item) return;
    palette.addSwatch(item);
};

beadLibrary.swapIn = item => {
    const myResult = item;

    const mySwatch = b3.store.state.swatches.find(element => element.selected);
    if (!mySwatch) return;

    palette.assign(mySwatch, {
        fillColor: myResult.fillColor,
        secondColor: null,
        letterCode: mySwatch.letterCode,
        finishName: myResult.finishName,
        inner: myResult.inner,
        description: myResult.description,
        id: mySwatch.id,
        selected: mySwatch.selected
    });
    // trigger unsaved!
    beads.refreshCanvas();
    historie.addAction();
};

beadLibrary.openPanel = () => {
    const method = b3.store.state.colorMatch ? 'color' : 'filter';
    beadLibrary.displayBeads({method});
    b3.ee.emit('resetBeadLibrary');
    b3.store.mySet('showingModal', 'library-modal');
};

beadLibrary.closePanel = () => {
    if (b3.store.state.showingModal === 'library-modal') {
        b3.store.mySet('showingModal', null);
    }
};

beadLibrary.sortBeadsByColor = (r, g, b) => {
    return getAllBeads()
        .filter(bead => bead.a === settings.library.index)
        .map(bead => overwrite(bead))
        .map(bead => {
            const rdist = Math.pow((r - bead.c[0]), 2);
            const gdist = Math.pow((g - bead.c[1]), 2);
            const bdist = Math.pow((b - bead.c[2]), 2);
            const distance = Math.sqrt(rdist + gdist + bdist);
            return {...bead, distance};
        })
        .sort((a, b) => a.distance - b.distance > 0 ? 1 : -1)
};

beadLibrary.filterBeads = str => {

    let result = getAllBeads()
        .filter(bead => bead.a === settings.library.index)
        .map(bead => overwrite(bead));

    str.split(' ').forEach(term => {
        result = result.filter(bead => (
            bead.t?.toLowerCase().includes(term) ||
            bead.title?.toLowerCase().includes(term) ||
            bead.details?.toLowerCase().includes(term) ||
            bead.description?.toLowerCase().includes(term) ||
            bead.dt?.toLowerCase().includes(term) ||
            bead.id?.toLowerCase().includes(term)
        ));
    });

    return result;
};
